import { render } from "./TakeSnapshot.vue?vue&type=template&id=77c69acc&scoped=true"
import script from "./TakeSnapshot.vue?vue&type=script&lang=js"
export * from "./TakeSnapshot.vue?vue&type=script&lang=js"

import "./TakeSnapshot.vue?vue&type=style&index=0&id=77c69acc&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c69acc"]])

export default __exports__